module.exports = __webpack_public_path__ + "assets/0dd111b8341688e722390252421de4ec.svg";


//////////////////
// WEBPACK FOOTER
// ./app/errors/assets/error.svg
// module id = 674
// module chunks = 0